import device from '../../utils/api/device'

export default {
    namespaced: true,
    state: {
        info: null,
        config: null,
        history: null,
        alarms: null,
        alarm: null,
        alias: null,
        id: null,
        accessLevel: null,
        canEdit: false
    },
    mutations: {
        setDeviceInfo(state, payload) {
            state.info = payload
        },
        setDeviceConfig(state, payload) {
            state.config = payload
        },
        setDeviceAlarm(state, payload) {
            state.alarm = payload
        },
        setDeviceHistory(state, payload) {
            state.history = payload
        },
        setAlarmsHistory(state, payload) {
            state.alarms = payload
        },
        setCurrentDevice(state, device) {
            if(device != null) {
                state.alias = device.alias
                state.id = device.deviceID
                state.accessLevel = device.accessLevel
                state.canEdit = device.accessLevel == 'admin'
            } else {
                state.alias = null
                state.id = null
                state.accessLevel = null
                state.canEdit = null
            }
            
        }   
    },
    actions: {
        getDevice({commit}, data) {
            return new Promise((resolve, reject) => {
                device.getDevice({token: data.token, deviceID: data.deviceID})
                .then((result) => {
                    if(result) {
                        commit('setDeviceInfo', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
           
        },
        getDeviceConfig({commit}, data) {
            return new Promise((resolve, reject) => {
                device.getDeviceConfig({token: data.token, deviceID: data.deviceID})
                .then((result) => {
                    if(result) {
                        commit('setDeviceConfig', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        getDeviceAlarm({commit}, data) {
            return new Promise((resolve, reject) => {
                device.getDeviceAlarm({token: data.token, deviceID: data.deviceID})
                .then((result) => {
                    if(result) {
                        commit('setDeviceAlarm', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        getDeviceHistory({commit}, data) {
            return new Promise((resolve, reject) => {
                device.getDeviceHistory({token: data.token, deviceID: data.deviceID, date: data.date, format: data.format})
                .then((result) => {
                    if(result) {
                        commit('setDeviceHistory', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        getAlarmHistory({commit}, data) {
            return new Promise((resolve, reject) => {
                device.getAlarmHistory({token: data.token, deviceID: data.deviceID, page: data.page, limit: data.limit, date: data.date, format: data.format })
                .then((result) => {
                    if(result) {
                        commit('setAlarmsHistory', result.alarms)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        updateDeviceConfig({commit}, data) {
            return new Promise((resolve, reject) => {
                device.updateDeviceConfig({token: data.token, deviceID: data.deviceID, data: data.data})
                .then((result) => {
                    if(result) {
                        commit('setDeviceConfig', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        updateAlarmConfig({commit}, data) {
            return new Promise((resolve, reject) => {
                let body = {};
                Object.keys(data.data).forEach((key) => {
                    if(data.data[key])
                    body[key] = data.data[key]
                    return 
                })
                device.updateAlarmConfig({token: data.token, deviceID: data.deviceID, data: body})
                .then((result) => {
                    if(result) {
                        commit('setDeviceAlarm', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        setCurrentDevice({commit}, device) {
            commit('setCurrentDevice', device)
        },
        addDevice({commit}, data) {
            return new Promise((resolve, reject) => {
                device.linkDevice({token: data.token, userID: data.userID, device: data.device})
                .then(() => {
                    resolve(true)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        removeDevice({commit}, data) {
            return new Promise((resolve, reject) => {
                device.unlinkDevice({token: data.token, userID: data.userID, deviceID: data.deviceID})
                .then((result) => {
                    commit('setCurrentDevice', {id: null, alias: null, accessLevel: null})
                    resolve(result)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        updateDevice({commit}, data) {
            return new Promise((resolve, reject) => {
                device.updateDevice({token: data.token, deviceID: data.deviceID, data: data.data})
                .then((result) => {
                    commit('setDeviceInfo', result)
                    resolve(result)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        clearDevice({commit}) {
            commit('setDeviceInfo', null)
            commit('setDeviceConfig', null)
            commit('setDeviceAlarm', null)
            commit('setCurrentDevice', null)
            return true
        }
    }
}